import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material"
import { default as platform} from "../../assets/platform.jpg"
import { default as mission} from "../../assets/mission.jpg"
import { theme } from "../../common/style/Theme"
import { default as fintech } from "../../assets/agri.jpg"

const Platform = () => {
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
    
    return (
        <Box>
            <Box style={{
                width: "100vw",
                height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px + 2vw)",
                position: "relative",
            }}>
                <img src={fintech} style={{
                    width: "100%",
                    height: "100%",
                    objectPosition: "left",
                    objectFit: "cover"
                }} alt="about-bg"/>
                <Box style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px + 2vw)",
                    opacity: 0.84,
                    background: theme.palette.common.black
                }} />
                <Grid container style={{
                    position: "absolute",
                    width: "100vw",
                    height: isMobile ? "90vh" : "calc(1rem * 25 + 2.1rem * 5 + 100px + 2vw)",
                    top: 0,
                    left: 0,
                    padding: isMobile ? "10vh 5vw" : isTablet ? "12vh 8vw" : "8vw 15vw"
                }}>   
                    <Grid size={{xs:12, sm:12, md:12, lg:12}} style={{
                        color: theme.palette.background.default,
                    }}>
                        <Typography variant="h2" style={{
                            textAlign: "center",
                            marginTop: isMobile ? "2vw" : isTablet ? "2.5vw" : "8vw",
                            color: theme.palette.common.white,
                        }}>
                            Bhommee
                        </Typography>
                        <Typography variant="h5" style={{
                            textAlign: "center",
                            marginBottom: isMobile ? "2vw" : isTablet ? "2.5vw" : "3vw",
                            marginTop: "-10px",
                        }}>
                            A digital agricultural platform for farmers
                        </Typography>
                        <Typography variant="body1" style={{
                            textAlign: "justify",
                            marginTop: "20px",
                            lineHeight: isMobile ? "1.6" : isTablet ? "1.7" : "1.5",
                        }}>
                            Bhoomee, an innovative initiative by M5 Info Solutions Private Limited, Bangalore, is redefining agriculture by uniting farmers, Farmer Producer Companies, Farmer Cooperatives, Agri-entrepreneurs, buyers, input sellers and service providers in a seamless, 360-degree inclusion ecosystem.
                            This first-of-its-kind platform leverages advanced cloud, mobile, and digital technologies, combined with a unique network of local Udyamis, to provide last-mile connectivity and equal opportunities for all farmers, regardless of smartphone access.
                            Multilingual and region-agnostic, Bhoomee supports every aspect of agriculture, fostering rural employment, empowering communities, and transforming farming into a sustainable, profitable enterprise. More than a platform, Bhoomee is a movement driving prosperity in agriculture.
                        </Typography>
                        <Box style={{
                            marginTop: "3vw",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }} onClick={() => window.open("https://bhoomee.co.in", "_blank")}>
                            <Button variant="contained">
                                Explore Our Platform
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                <Box style={{
                    width: "100vw",
                    height: isMobile ? "50vh" : isTablet ? "60vh" : "70vh",
                    paddingTop: "5vw"
                }}>
                    <img src={platform} alt="Platform" style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                    }} />
                </Box>
            </Box>
            <Grid container style={{
                marginTop: "5vw",
                padding: isMobile ? "5vw 5vw" : isTablet ? "4vw 8vw" : "3vw 10vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: theme.palette.background.paper,
            }}>
                <Grid size={{ xs: 12, sm: 12, md: 5, lg: 5}} style={{
                    order: isMobile ? 2 : 1,
                    marginTop: isMobile ? "30px" : "0",
                }}>
                    <img src={mission} alt="Mission" style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "center",
                    }} />
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 7, lg: 7}} style={{
                    padding: isMobile ? "0 2vw" : isTablet ? "0 2.5vw" : "0 3vw",
                    order: isMobile ? 1 : 2,
                    textAlign: isMobile ? "center" : "left",
                }}>
                    <Typography variant="h2" style={{
                        textAlign: isMobile ? "center" : "center",
                        color: theme.palette.primary.main,
                        marginBottom: isMobile ? "2vw" : isTablet ? "2.5vw" : "3vw",
                    }}>
                        Our Mission
                    </Typography>
                    <Typography variant="body1" style={{
                        textAlign: isMobile ? "center" : "center",
                        lineHeight: isMobile ? "1.6" : isTablet ? "1.7" : "1.5",
                    }}>
                        Our mission is to empower every stakeholder in the agricultural community – farmers, suppliers, buyers, and service providers – by providing a dynamic digital platform that fosters seamless collaboration, drives profitability, and enables data-driven decision-making. We aim to revolutionize agriculture through innovation, transforming it into a sustainable and inclusive ecosystem that delivers impactful insights and growth opportunities for all.
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{
                padding: isMobile ? "5vw 5vw" : isTablet ? "4vw 8vw" : "5vw 10vw"
            }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12}} style={{
                    padding: isMobile ? "4vw" : isTablet ? "3.5vw" : "3vw",
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                    borderRadius: "10px",
                }}>
                    <Typography variant="h3">
                        What does Bhoomee offer?
                    </Typography>
                    <Typography variant="body1" style={{
                        marginTop: "20px",
                        lineHeight: isMobile ? "1.6" : isTablet ? "1.7" : "1.85",
                    }}>
                        Bhoomee offers more than just a platform – we deliver a comprehensive solution tailored to meet the needs of every agricultural stakeholder. From enhancing farmer visibility and entrepreneurship to equipping suppliers and buyers with real-time insights, we drive impactful connections across the agri-ecosystem. With Bhoomee, you gain access to a rich repository of actual data, empowering informed decision-making and ensuring a sustainable and profitable future for agriculture.
                    </Typography>
                </Grid>
            </Grid>
        </Box>
        
    )
}

export default Platform